import React, { memo, useState, useEffect } from 'react'
import { getData } from '../../../assets/scripts/GeneralFunctions'
import CarCode from '../../content/views/cars/child/CarCode'
import { select_class, title_class } from '../../../functions/stateList'
import CarInfoTable from '../../tabels/CarInfoTable'
import CarInfoUser from '../../tabels/CarInfoUser'
import ServiceDateSection from '../../content/views/service/child/ServiceDateSection'
import HistoryButton from '../../buttons/HistoryButton'
import { Images } from '../../../assets/scripts/Images'

function CarInfo({ isUser }) {
  const [car, setCar] = useState({})
  const [customer, setCustomer] = useState({})
  const [code, setCode] = useState('')
  const [lastVisit, setLastVisit] = useState({})
  const [cars, setCars] = useState([])

  const default_token = localStorage.getItem('userToken')

  useEffect(() => {
    async function fetchData() {
      let api_result = await getData(`customer/cars`, 'get', {}, true, false, default_token)
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          if (result_data?.cars?.length > 0) {
            setCar(result_data?.cars[0])
            setCode(result_data?.cars[0]?.id)
            let visits = result_data?.cars[0]?.['visits']
            if (visits?.length > 0) setLastVisit(visits[visits?.length - 1])
          }

          setCars(result_data?.cars)
          setCustomer(result_data?.customer)
        }
      }
    }

    fetchData()
  }, [])

  async function fetchData(code) {
    let api_result = await getData(`customer/cars/${code}`, 'get', {}, true, false, default_token)
    if (api_result) {
      if (api_result?.status === 200) {
        let result_data = api_result?.data
        let visits = result_data?.car?.['visits']
        setLastVisit(visits[visits?.length - 1])
        setCar(result_data?.car)
      }
    }
  }

  const carHandler = async (e) => {
    let value = e.target.value
    setCode(value)
    await fetchData(value)
  }
  return (
    <div className={'mx-6 md:mx-auto md:py-8 md:max-w-[1480px]'}>
      <div className="flex item-center justify-center">
        <img
          src={Images.logo}
          className={'w-fit h-fit block dark:hidden'}
          alt="milani auto clinic"
        />
        <img
          src={Images.lightLogo}
          className={'w-fit h-fit hidden dark:block'}
          alt="milani auto clinic"
        />
      </div>
      <CarCode isUser={true} title={'اطلاعات و خدمات خودرو '} code={car?.code} />
      <div className="flex flex-col mb-16">
        <h2 className={title_class}>اطلاعات خودرو</h2>
        {cars?.length > 1 && (
          <div className="flex flex-col sm:flex-row sm:items-center mt-3 mb-4">
            <div className="flex items-center justify-start">
              <i className={'icon-car pl-2 text-xl dark:text-slate-200'} />
              <h3 className={'text-black text-base dark:text-slate-200'}>
                خودرو خود را انتخاب کنید
              </h3>
            </div>
            <select
              className={`${select_class} w-full sm:w-fit mr-auto`}
              name="date"
              id="name"
              value={code}
              onChange={carHandler}
              defaultValue={car?.id}
            >
              {cars?.map((info, index) => (
                <option className={'dark:highlight-amber-100'} value={info.id} key={index}>
                  {info?.car_model?.model} - {info?.code}
                </option>
              ))}
            </select>
          </div>
        )}
        <CarInfoTable isUser={true} car={car} />
      </div>

      <div className="flex flex-col mb-16">
        <h2 className={title_class}>اطلاعات فردی</h2>
        <CarInfoUser isUser={isUser} customer={customer} />
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <h2 className={title_class}>آخرین خدمات اجرا شده</h2>
        {car?.['visits']?.length > 1 && (
          <HistoryButton isUser={true} link={`car/${car?.id}/service`} title={'تاریخچه خدمات'} />
        )}
      </div>

      <ServiceDateSection lastVisit={lastVisit} isUser={isUser} />
    </div>
  )
}

export default memo(CarInfo)
